export default __webpack_public_path__ + "static/media/icon-twitter-d.464f2e75.svg";